import React from 'react'
import Logo from "../assets/logo/log_white.jpg"
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div>
        <footer className="footer-area">
            <div className="footer-widget">
                <div className="container">
                    <div className="row footer-widget-wrapper pt-120 pb-70">
                        <div className="col-md-6 col-lg-4">
                            <div className="footer-widget-box about-us">
                                <Link to="/" className="footer-logo">
                                    <img src={Logo} alt="ServiSwift Logo"/>
                                </Link>
                                <p className="mb-3">
                                ServiSwift is your all-in-one platform for connecting with reliable service providers. 
                                We ensure a seamless, efficient, and hassle-free experience. 
                                ServiSwift simplifies your daily needs with just a few taps.
                                </p>
                                <ul className="footer-contact">
                                    <li><Link to="tel:+265992592759"><i className="pi pi-whatsapp"></i> +265 992 592 759</Link></li>
                                    <li><i className="pi pi-map-marker"></i> Sunnyside, Blantyre Malawi</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-2">
                            <div className="footer-widget-box list">
                                <h4 className="footer-widget-title">Quick Links</h4>
                                <ul className="footer-list">
                                    <li><Link to="/about"><i className="pi pi-arrow-right"></i> About Us</Link></li>
                                    <li><Link to="/blogs"><i className="pi pi-arrow-right"></i> Latest News</Link></li>
                                    <li><Link to="/terms-of-reference"><i className="pi pi-arrow-right"></i> Terms of Service</Link></li>
                                    <li><Link to="/privacy"><i className="pi pi-arrow-right"></i> Privacy Policy</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="footer-widget-box list">
                                <h4 className="footer-widget-title">Support Center</h4>
                                <ul className="footer-list">
                                    <li><Link to="/"><i className="pi pi-arrow-right"></i> FAQs</Link></li>
                                    <li><Link to="/contact"><i className="pi pi-arrow-right"></i> Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <div className="footer-widget-box list">
                                <h4 className="footer-widget-title">Newsletter</h4>
                                <div className="footer-newsletter">
                                    <p>Subscribe to our newsletter for the latest updates, offers, and more!</p>
                                    <div className="subscribe-form">
                                        <form action="/">
                                            <input type="email" className="form-control" placeholder="Your Email" required/>
                                            <button className="theme-btn" type="submit">
                                                Subscribe Now <i className="far fa-paper-plane"></i>
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 align-self-center">
                            <p className="copyright-text">
                                &copy; <span id="date"></span> <Link to="/">ServiSwift</Link>. All Rights Reserved.
                            </p>
                        </div>
                        <div className="col-md-6 align-self-center">
                            <ul className="footer-social">
                                <li><Link to="/"><i className="fab fa-facebook-f"></i></Link></li>
                                <li><Link to="/"><i className="fab fa-twitter"></i></Link></li>
                                <li><Link to="/"><i className="fab fa-linkedin-in"></i></Link></li>
                                <li><Link to="/"><i className="fab fa-youtube"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

    </div>
  )
}

export default Footer